import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Card } from "react-bootstrap";
import { Button, Modal, Form, Badge } from "react-bootstrap";
import GoBack from "../General/GoBack";
import ModalAsignacionEquipos from "./ModalAsignarEquipo";
import API_URL from "../../localhost/config"; //Importa la variable global
import Sidebar from "../Sidebar/Sidebar";

function Turnos() {
  const { idTorneo } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [showModalAsignarEquipos, setModalAsignarEquipos] = useState(false);
  const [turnoAMostrar, setTurnoMostrar] = useState(null);
  const [horario, setHorario] = useState("");

  const [dias, setDias] = useState([]);
  const [diaSeleccionado, setDiaSeleccionado] = useState("");

  const [canchas, setCanchas] = useState([]); //Trae todas las canchas segun el idTorneo
  const [nuevaCancha, setNuevaCancha] = useState("");
  const [canchaSeleccionada, setCanchaSeleccionada] = useState("");

  const [turnos, setTurnos] = useState([]);

  const [postTurnos, setPostTurnos] = useState(false);
  const [postCancha, setPostCancha] = useState(false);

  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [turnoAEliminar, setTurnoAEliminar] = useState(null);

  // Filtro
  const [filtroDia, setFiltroDia] = useState("");
  const [filtroCancha, setFiltroCancha] = useState("");
  const [filtroHorario, setFiltroHorario] = useState("");
  const [filtroHabilitado, setFiltroHabilitado] = useState("");

  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  const [isLoading, setIsLoading] = useState(false); // Estado para controlar si los datos están cargados

  const handleShow = (event) => {
    event.preventDefault();
    setShowModal(true);
    setError("");
  };

  const showModalEquipo = (turno) => {
    setModalAsignarEquipos(true);
    setTurnoMostrar(turno);
  };

  const closeModalEquipo = () => {
    setModalAsignarEquipos(false);
  };

  const handleClose = () => {
    setShowModal(false);
    setErrorModal("");
    setNuevaCancha("");
  };

  const [error, setError] = useState("");
  const [errorModal, setErrorModal] = useState("");

  useEffect(() => {
    fetch(`${API_URL}/getCanchas?idTorneo=${idTorneo}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((canchas) => {
        setCanchas(canchas);
      });
  }, [idTorneo, postCancha]);

  useEffect(() => {
    fetch(`${API_URL}/getDias`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((dias) => {
        setDias(dias);
      });
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/getTurns?idTorneo=${idTorneo}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((turnos) => {
        setTurnos(turnos);
      });
  }, [idTorneo, postTurnos]);

  const handleEliminarTurno = async (idTurno) => {
    setShowModalConfirmation(true);
    setTurnoAEliminar(idTurno);
  };

  const confirmarEliminacion = async (idTurno) => {
    setShowModalConfirmation(false);

    try {
      // Realizar la solicitud DELETE a la API para eliminar el turno
      await axios.delete(`${API_URL}/deleteTurn/${idTurno}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Actualizar la lista de turnos después de eliminar el turno
      const nuevosTurnos = turnos.filter((turno) => turno.id !== idTurno);
      setTurnos(nuevosTurnos);
    } catch (error) {
      console.error("Error al eliminar el turno:", error.message);
      setError("Error al eliminar el turno.");
    }
  };

  const handleEliminarCanchaCargada = async (idCancha) => {
    try {
      // Realizar la solicitud DELETE a la API para eliminar la cancha
      await axios.delete(`${API_URL}/deleteCancha/${idCancha}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Actualizar la lista de canchas después de eliminar la cancha
      const nuevasCanchasActualizadas = canchas.filter(
        (cancha) => cancha.id !== idCancha
      );
      setCanchas(nuevasCanchasActualizadas);
    } catch (error) {
      console.error("Error al eliminar la cancha:", error.message);
    }
  };

  const handleHorarioChange = (e) => {
    const input = e.target.value;

    // Permitir solo dígitos y dos puntos (:)
    const regex = /^[\d:]*$/;

    // Filtrar solo los primeros 5 caracteres que cumplan con la expresión regular
    const formattedInput = input.substring(0, 5).replace(/[^\d:]/g, "");

    // Verificar que la entrada cumpla con la longitud y la expresión regular
    if (formattedInput.length <= 5 && regex.test(formattedInput)) {
      // Formatear automáticamente HH: si se ingresan dos caracteres
      if (formattedInput.length === 2 && !formattedInput.includes(":")) {
        setHorario(formattedInput + ":");
      } else {
        setHorario(formattedInput);
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const regexHorario = /^([01]\d|2[0-3]):[0-5]\d$/;

    // Validar que los campos obligatorios no estén vacíos
    if (!canchaSeleccionada || !diaSeleccionado || !horario) {
      setError("Todos los campos son obligatorios.");
      return;
    } else if (!regexHorario.test(horario)) {
      setError("El horario no cumple con el formato requerido de HH:MM.");
      return;
    } else {
      // Limpiar el mensaje de error si no hay errores
      setError("");
    }

    // Obtener el objeto de la cancha seleccionada
    const cancha = canchas.find((c) => c.id === parseInt(canchaSeleccionada));

    // Obtener el objeto del día seleccionado
    const dia = dias.find((d) => d.id === parseInt(diaSeleccionado));

    // Verificar si ya existe un turno con la misma cancha, día y horario
    const turnoExistente = turnos.find(
      (turno) =>
        turno.idCancha === cancha.id &&
        turno.idDia === dia.id &&
        turno.horario === horario
    );

    if (turnoExistente) {
      setError("Ya existe un turno con la misma cancha, día y horario.");
      return;
    }

    const nuevoTurno = {
      cancha: cancha.Nombre,
      dia: dia.Dia,
      idCancha: cancha.id,
      idDia: dia.id,
      horario: horario,
    };

    setHorario(""); // Limpiar el campo de horario después de agregar el turno

    try {
      // Realizar la solicitud POST a la API con los turnos
      const turnosTransformados = [
        {
          idCancha: nuevoTurno.idCancha,
          idDia: nuevoTurno.idDia,
          horario: nuevoTurno.horario,
        },
      ];

      const bodyTurnos = { turnos: turnosTransformados, idTorneo: idTorneo };

      await axios.post(`${API_URL}/turnos`, bodyTurnos, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPostTurnos(true);
    } catch (error) {
      setError("Error al enviar los turnos:", error.message);
    }
    setPostTurnos(Date.now());
  };

  const handleAgregarCancha = async () => {
    // Verificar que el nombre sea único entre nuevasCanchas y canchas
    const nombreUnico = !canchas.some(
      (cancha) =>
        cancha.Nombre.toLowerCase() === nuevaCancha.trim().toLowerCase()
    );

    if (nuevaCancha.trim() !== "" && nombreUnico) {
      setNuevaCancha("");
      setErrorModal("");
      setPostCancha((prevPostCancha) => !prevPostCancha);

      try {
        // Crear canchas
        const canchasTransformadas = [
          {
            nombre: nuevaCancha,
            idTorneo: idTorneo,
          },
        ];

        const bodyCanchas = { canchas: canchasTransformadas };

        const responseCanchas = await axios.post(
          `${API_URL}/canchas`,
          bodyCanchas,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (responseCanchas.data) {
          console.log(
            "Respuesta de la creación de canchas:",
            responseCanchas.data
          );
        } else {
          setErrorModal(
            "La respuesta para la creación de canchas no tiene la estructura esperada"
          );
        }
      } catch (error) {
        console.error(
          "Error al realizar las solicitudes:",
          error.response?.data?.message || error.message
        );
      }
    } else {
      // Lógica para manejar el caso en el que el nombre no es único o está vacío
      setErrorModal(
        "El nombre de la cancha esta vacio o ya se encuentra creada"
      );
    }
    setPostCancha(Date.now());
  };

  // Función para filtrar los turnos según los filtros aplicados
  const filtrarTurnos = (turnos) => {
    return turnos.filter((turno) => {
      // Aplicar filtros si existen
      const cumpleFiltroDia = filtroDia === "" || turno.dia.includes(filtroDia);
      const cumpleFiltroCancha =
        filtroCancha === "" || turno.cancha.includes(filtroCancha);
      const cumpleFiltroHorario =
        filtroHorario === "" || turno.horario.includes(filtroHorario);
      const cumpleFiltroHabilitado =
        filtroHabilitado === "" ||
        (filtroHabilitado === "habilitado" && turno.habilitado) ||
        (filtroHabilitado === "deshabilitado" && !turno.habilitado);
      return (
        cumpleFiltroDia &&
        cumpleFiltroCancha &&
        cumpleFiltroHorario &&
        cumpleFiltroHabilitado
      );
    });
  };

  // Obtener todas las opciones únicas de cancha, horario y día
  const opcionesCancha = [...new Set(turnos.map((turno) => turno.cancha))];
  const opcionesDia = [...new Set(turnos.map((turno) => turno.dia))];
  const opcionesHorario = [...new Set(turnos.map((turno) => turno.horario))];

  // Event handlers para actualizar los filtros
  const handleChangeFiltroDia = (e) => {
    setFiltroDia(e.target.value);
  };

  const handleChangeFiltroCancha = (e) => {
    setFiltroCancha(e.target.value);
  };

  const handleChangeFiltroHorario = (e) => {
    setFiltroHorario(e.target.value);
  };

  const handleChangeFiltroHabilitado = (e) => {
    setFiltroHabilitado(e.target.value);
  };

  const handleToggleHabilitado = async (turnoId, nuevoEstado) => {
    // Encuentra el turno correspondiente en la lista de turnos
    const turnoIndex = turnos.findIndex((turno) => turno.id === turnoId);
    if (turnoIndex === -1) {
      // Si no se encuentra el turno, salir de la función
      return;
    }

    // Actualiza el estado del turno con el nuevo estado
    setTurnos((prevTurnos) => {
      const newTurnos = [...prevTurnos];
      newTurnos[turnoIndex] = {
        ...newTurnos[turnoIndex],
        habilitado: nuevoEstado,
      };
      return newTurnos;
    });

    const url = `${API_URL}/enableTurn`;
    const data = {
      actived: nuevoEstado,
      idTurno: turnoId,
    };

    try {
      await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Error al actualizar el turno:", error.message);
    }
  };

  return (
    <div className="row p-0 g-0">
      <div className="col-sm-auto p-0 g-0 flex-column">
        <Sidebar> </Sidebar>
      </div>
      {isLoading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="col-sm-6 px-5 g-0 mx-auto">
          <div className="section-title mt-5">
            <h3>
              Administrar <span>turnos</span>
            </h3>
          </div>

          <div
            className="row justify-content-center p-0 g-0"
            style={{
              marginBottom: "20px",
              borderBottom: "1px solid #ccc",
            }}
          >
            {error && <div className="alert alert-danger">{error}</div>}

            <form
              onSubmit={handleSubmit}
              className="row p-0"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="col-sm">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Cancha
                    <span style={{ marginLeft: "auto" }}>
                      <button
                        variant="primary"
                        onClick={handleShow}
                        style={{
                          cursor: "pointer",
                          padding: "5px",
                          lineHeight: "0",
                          fontSize: "1.5rem",
                        }}
                      >
                        +
                      </button>
                    </span>
                  </label>
                  <select
                    className="form-control"
                    value={canchaSeleccionada}
                    onChange={(e) => setCanchaSeleccionada(e.target.value)}
                    style={{ marginRight: "10px", flex: "1" }}
                  >
                    <option value="" disabled>
                      Selecciona una cancha
                    </option>
                    {canchas.map((cancha) => (
                      <option key={cancha.id} value={cancha.id}>
                        {cancha.Nombre}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Día</label>
                  <select
                    className="form-control"
                    value={diaSeleccionado}
                    onChange={(e) => setDiaSeleccionado(e.target.value)}
                  >
                    <option value="" disabled>
                      Selecciona un día
                    </option>
                    {dias
                      .sort((a, b) => a.id - b.id)
                      .map((dia) => (
                        <option key={dia.id} value={dia.id}>
                          {dia.Dia}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-sm">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Horario</label>
                  <input
                    type="text"
                    className="form-control m-0"
                    value={horario}
                    onChange={handleHorarioChange}
                    placeholder="HH:MM"
                  />
                </div>
              </div>{" "}
              <button
                type="submit"
                className="btn btn-success mt-3"
                style={{ marginBottom: "20px" }}
              >
                Confirmar turno
              </button>
            </form>
          </div>

          <div className="row g-0 align-items-center ">
            {/* Controles de filtro */}
            <div className="row g-0 d-flex mb-3">
              {/* <h4 className="me-3">Filtros:</h4> */}
              <select
                value={filtroDia}
                className="col form-control me-3"
                onChange={handleChangeFiltroDia}
              >
                <option value="">Todos los días</option>
                {opcionesDia.map((dia) => (
                  <option key={dia} value={dia}>
                    {dia}
                  </option>
                ))}
              </select>
              <select
                value={filtroCancha}
                className="col form-control me-3"
                onChange={handleChangeFiltroCancha}
              >
                <option value="">Todas las canchas</option>
                {opcionesCancha.map((cancha) => (
                  <option key={cancha} value={cancha}>
                    {cancha}
                  </option>
                ))}
              </select>
              <select
                value={filtroHorario}
                className="col form-control me-3"
                onChange={handleChangeFiltroHorario}
              >
                <option value="">Todos los horarios</option>
                {opcionesHorario.map((horario) => (
                  <option key={horario} value={horario}>
                    {horario}
                  </option>
                ))}
              </select>
              <select
                value={filtroHabilitado}
                className="col form-control"
                onChange={handleChangeFiltroHabilitado}
              >
                <option value="">Todos los turnos</option>
                <option value="habilitado">Habilitados</option>
                <option value="deshabilitado">Deshabilitados</option>
              </select>
            </div>
            <div className="row g-0">
              {/* Mostrar la tabla solo si hay turnos */}
              {filtrarTurnos(turnos).length > 0 ? (
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>Cancha</th>
                      <th>Día</th>
                      <th>Horario</th>
                      <th>Acciones</th>
                      <th></th>{" "}
                    </tr>
                  </thead>
                  <tbody>
                    {filtrarTurnos(turnos).map((turno) => (
                      <tr
                        key={turno.id}
                        className={`turno-fila ${
                          !turno.habilitado ? "turno-deshabilitado" : ""
                        }`}
                      >
                        <td>{turno.cancha}</td>
                        <td>{turno.dia}</td>
                        <td>{turno.horario}</td>

                        <td className="d-flex align-items-center">
                          <div>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => handleEliminarTurno(turno.id)}
                            >
                              X
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary ms-2"
                              onClick={() => showModalEquipo(turno)}
                            >
                              ✏️
                            </button>
                          </div>
                        </td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`switch-${turno.id}`}
                              role="switch"
                              onChange={(e) =>
                                handleToggleHabilitado(
                                  turno.id,
                                  e.target.checked
                                )
                              }
                              checked={turno.habilitado}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No hay turnos para los filtros seleccionados.</p>
              )}
            </div>
          </div>
        </div>
      )}

      <ModalAsignacionEquipos
        showModal={showModalAsignarEquipos}
        onHide={closeModalEquipo}
        turno={turnoAMostrar}
      />

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Administrar canchas</Modal.Title>
        </Modal.Header>
        {errorModal && <div className="alert alert-danger">{errorModal}</div>}

        <Modal.Body style={{ textAlign: "left" }}>
          {" "}
          {/* Establecer alineación a la izquierda */}
          <div className="form">
            <div className="row">
              <div className="col-sm-6">
                <Form.Control
                  type="text"
                  placeholder="Ingrese el nombre de la nueva cancha"
                  value={nuevaCancha}
                  onChange={(e) => setNuevaCancha(e.target.value)}
                />
              </div>
              <div className="col-sm-6 d-flex justify-content-end">
                <Button
                  variant="primary"
                  onClick={() => handleAgregarCancha(nuevaCancha)}
                >
                  Agregar cancha
                </Button>
              </div>
            </div>
            <hr />
            <table>
              <tbody>
                {canchas.map((cancha) => (
                  <tr key={cancha.id}>
                    <td>{cancha.Nombre}</td>
                    <td>
                      <i
                        className="fa fa-times"
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={() => handleEliminarCanchaCargada(cancha.id)}
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalConfirmation}
        onHide={() => setShowModalConfirmation(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Advertencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Al eliminar este turno, perderás la configuración que agregaste para
          cada equipo. ¿Estás seguro de que deseas eliminarlo?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalConfirmation(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={() => confirmarEliminacion(turnoAEliminar)}
          >
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Turnos;
